import { useUpdateMedComplexMutation } from '@/api'
import { Input } from '@/components'
import { useModal } from '@/hooks'
import { ModalType } from '@/store/app'
import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'
import { useContext, useEffect } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { MedComplexContext } from '../../MedComplex'
import { Accordion } from '../../components'
import { CheckMarkIcon, ResetIcon } from '../../icons'
import { styles } from '../../styles'

export const ConfigurationInfo = () => {
  const { medcomplex, refetch } = useContext(MedComplexContext)
  const { showModal } = useModal()
  const [updateMedComplex] = useUpdateMedComplexMutation()

  const defaults = {
    temp_upper: String(medcomplex?.temp_upper),
    temp_lower: String(medcomplex?.temp_lower),
    humidity_upper: String(medcomplex?.humidity_upper),
    humidity_lower: String(medcomplex?.humidity_lower),
    luminosity_upper: String(medcomplex?.luminosity_upper),
    luminosity_lower: String(medcomplex?.luminosity_lower),
  }

  const configDataForm = useForm({
    defaultValues: defaults,
  })
  const watchConfig = configDataForm.watch([
    'temp_upper',
    'temp_lower',
    'humidity_upper',
    'humidity_lower',
    'luminosity_upper',
    'luminosity_lower',
  ])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSubmit = (values: any) => {
    console.log(1)

    updateMedComplex({
      id: medcomplex?.id,
      payload: {
        temp_upper: Number(values.temp_upper.replace(',', '.')),
        temp_lower: Number(values.temp_lower.replace(',', '.')),
        humidity_upper: Number(values.humidity_upper),
        humidity_lower: Number(values.humidity_lower),
        luminosity_upper: Number(values.luminosity_upper),
        luminosity_lower: Number(values.luminosity_lower),
      },
    }).then(() => refetch())
    showModal(ModalType.MEDCOMPLEX_COMPLETE_CONFIG)
  }

  const handleResetConfig = () => {
    configDataForm.reset({
      temp_upper: '35',
      temp_lower: '10',
      humidity_upper: '80',
      humidity_lower: '10',
      luminosity_upper: '1000',
      luminosity_lower: '0',
    })
  }

  useEffect(() => {
    configDataForm.reset({
      temp_upper: String(medcomplex?.temp_upper),
      temp_lower: String(medcomplex?.temp_lower),
      humidity_upper: String(medcomplex?.humidity_upper),
      humidity_lower: String(medcomplex?.humidity_lower),
      luminosity_upper: String(medcomplex?.luminosity_upper),
      luminosity_lower: String(medcomplex?.luminosity_lower),
    })
  }, [medcomplex])

  // const common = {
  //   mask: Number,
  //   lazy: false,
  //   autofix: true,
  // }
  // const tempMask = {
  //   ...common,
  //   min: 0,
  //   max: 40,
  //   scale: 2,
  // }
  // const humidityMask = {
  //   ...common,
  //   min: 10,
  //   max: 99,
  // }
  // const luminosityMask = {
  //   ...common,
  //   min: 0,
  //   max: 1000,
  //   thousandsSeparator: ' ',
  // }
  // const tempMaskUpper = [{ ...tempMask, min: Number(watchConfig[1] ?? 0) }]
  // const tempMaskLower = [{ ...tempMask, max: Number(watchConfig[0] ?? 40) }]
  // const humidityMaskUpper = [
  //   { ...humidityMask, min: Number(watchConfig[3] ?? 10) },
  // ]
  // const humidityMaskLower = [
  //   { ...humidityMask, max: Number(watchConfig[2] ?? 99) },
  // ]
  // const luminosityMaskUpper = [
  //   { ...luminosityMask, min: Number(watchConfig[5] ?? 0) },
  // ]
  // const luminosityMaskLower = [
  //   { luminosityMask, max: Number(watchConfig[4] ?? 1000) },
  // ]

  const common = { mask: Number, lazy: false, autofix: true }
  const tempMaskUpper = [{ ...common, min: 0, max: 40, scale: 2 }]
  const tempMaskLower = [{ ...common, min: 0, max: 40, scale: 2 }]
  const humidityMaskUpper = [{ ...common, min: 10, max: 99 }]
  const humidityMaskLower = [{ ...common, min: 10, max: 99 }]
  const luminosityMaskUpper = [
    {
      ...common,
      min: 0,
      max: 1000,
      thousandsSeparator: ' ',
    },
  ]
  const luminosityMaskLower = [
    {
      ...common,
      min: 0,
      max: 1000,
      thousandsSeparator: ' ',
    },
  ]

  return (
    <FormProvider {...configDataForm}>
      <form onSubmit={configDataForm.handleSubmit(onSubmit)}>
        <Stack gap={'8px'}>
          <Box sx={{ marginLeft: 'auto' }}>
            <Stack direction={'row'} gap={'12px'}>
              <Button variant="outlined" onClick={handleResetConfig}>
                <Stack
                  direction={'row'}
                  gap={'4px'}
                  sx={{ marginBottom: '-4px' }}
                >
                  <ResetIcon />
                  Сброс
                </Stack>
              </Button>
              <Button
                variant="contained"
                type="submit"
                // onClick={handleSetNewConfig}
                // disabled={!watchConfig.every((item: string) => Boolean(item))}
              >
                <Stack
                  direction={'row'}
                  gap={'4px'}
                  sx={{ marginBottom: '-4px' }}
                >
                  <CheckMarkIcon />
                  Применить параметры
                </Stack>
              </Button>
            </Stack>
          </Box>
          <Accordion title={'Температура'} defaultExpanded>
            <TableContainer>
              <Table sx={styles.table}>
                <TableBody>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Верхний порог, &deg;C
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="00,00"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.temp_upper
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 5,
                          }}
                          // name="temp_upper"
                          mask={tempMaskUpper}
                          unmask
                          {...configDataForm.register('temp_upper', {
                            required: {
                              value: true,
                              message: 'Поле не должно быть пустым',
                            },
                            validate: {
                              validateNumber: (_, v) =>
                                (Number(v.temp_upper) > Number(v.temp_lower) &&
                                  Math.abs(
                                    Number(v.temp_upper) - Number(v.temp_lower)
                                  ) >= 10) ||
                                'Верхний порог должен превышать Нижний минимум на 10 °C',
                            },
                          })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {configDataForm.formState.errors.temp_upper?.message}
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Нижний порог, &deg;C
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="00,00"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.temp_lower
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 5,
                          }}
                          // name="temp_lower"
                          mask={tempMaskLower}
                          unmask
                          {...configDataForm.register('temp_lower', {
                            required: {
                              value: true,
                              message: 'Поле не должно быть пустым',
                            },
                            validate: {
                              validateNumber: (_, v) =>
                                (Number(v.temp_upper) > Number(v.temp_lower) &&
                                  Math.abs(
                                    Number(v.temp_upper) - Number(v.temp_lower)
                                  ) >= 10) ||
                                'Нижний порог должен быть ниже Верхнего минимум на 10 °C',
                            },
                          })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {configDataForm.formState.errors.temp_lower?.message}
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Accordion>
          <Accordion title={'Влажность'} defaultExpanded>
            <TableContainer>
              <Table sx={styles.table}>
                <TableBody>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Верхний порог, %
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="00 %"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.humidity_upper
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 5,
                          }}
                          // name="humidity_upper"
                          mask={humidityMaskUpper}
                          unmask
                          {...configDataForm.register('humidity_upper', {
                            required: {
                              value: true,
                              message: 'Поле не должно быть пустым',
                            },
                            validate: {
                              validateNumber: (_, v) =>
                                (Number(v.humidity_upper) >
                                  Number(v.humidity_lower) &&
                                  Math.abs(
                                    Number(v.humidity_upper) -
                                      Number(v.humidity_lower)
                                  ) >= 10) ||
                                'Верхний порог должен превышать Нижний минимум на 10 %',
                            },
                          })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {
                            configDataForm.formState.errors.humidity_upper
                              ?.message
                          }
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Нижний порог, %
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="00 %"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.humidity_lower
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 5,
                          }}
                          // name="humidity_lower"
                          mask={humidityMaskLower}
                          unmask
                          {...configDataForm.register('humidity_lower', {
                            required: {
                              value: true,
                              message: 'Поле не должно быть пустым',
                            },
                            validate: {
                              validateNumber: (_, v) =>
                                (Number(v.humidity_upper) >
                                  Number(v.humidity_lower) &&
                                  Math.abs(
                                    Number(v.humidity_upper) -
                                      Number(v.humidity_lower)
                                  ) >= 10) ||
                                'Нижний порог должен быть ниже Верхнего минимум на 10 %',
                            },
                          })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {
                            configDataForm.formState.errors.humidity_lower
                              ?.message
                          }
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Accordion>
          <Accordion title={'Освещенность'} defaultExpanded>
            <TableContainer>
              <Table sx={styles.table}>
                <TableBody>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Верхний порог, lux
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="0000"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.luminosity_upper
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 4,
                          }}
                          name="luminosity_upper"
                          // mask={luminosityMaskUpper}
                          // {...configDataForm.register('luminosity_upper', {
                          //   required: {
                          //     value: true,
                          //     message: 'Поле не должно быть пустым',
                          //   },
                          //   validate: {
                          //     validateNumber: (_, v) =>
                          //       (Number(v.luminosity_upper) >
                          //         Number(v.luminosity_lower) &&
                          //         Math.abs(
                          //           Number(v.luminosity_upper) -
                          //             Number(v.luminosity_lower)
                          //         ) >= 10) ||
                          //       'Верхний порог должен превышать Нижний минимум на 10 lux',
                          //   },
                          // })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {
                            configDataForm.formState.errors.luminosity_upper
                              ?.message
                          }
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell width={'30%'} sx={{ verticalAlign: 'middle' }}>
                      Нижний порог, lux
                    </TableCell>
                    <TableCell>
                      <Stack
                        direction={'row'}
                        gap={'8px'}
                        alignItems={'center'}
                      >
                        <Input
                          placeholder="0000"
                          sx={{
                            '&.MuiTextField-root .MuiInputBase-root.MuiFilledInput-root':
                              {
                                borderColor: configDataForm?.formState
                                  ?.dirtyFields?.luminosity_lower
                                  ? '#33C341'
                                  : 'none',
                              },
                            input: {
                              paddingTop: '7px',
                            },
                          }}
                          inputProps={{
                            maxLength: 4,
                          }}
                          // mask={luminosityMaskLower}
                          name="luminosity_lower"
                          // {...configDataForm.register('luminosity_lower', {
                          //   required: {
                          //     value: true,
                          //     message: 'Поле не должно быть пустым',
                          //   },
                          //   validate: {
                          //     validateNumber: (_, v) =>
                          //       (Number(v.luminosity_upper) >
                          //         Number(v.luminosity_lower) &&
                          //         Math.abs(
                          //           Number(v.luminosity_upper) -
                          //             Number(v.luminosity_lower)
                          //         ) >= 10) ||
                          //       'Нижний порог должен быть ниже Верхнего минимум на 10 lux',
                          //   },
                          // })}
                        />
                        <Box
                          sx={{
                            overflow: 'hidden',
                            wordWrap: 'break-word',
                            width: '280px',
                            color: 'red',
                            fontSize: '14px',
                          }}
                        >
                          {
                            configDataForm.formState.errors.luminosity_lower
                              ?.message
                          }
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Accordion>
        </Stack>
      </form>
    </FormProvider>
  )
}
